import { computed, defineComponent } from 'vue'

export default defineComponent({
  name: 'KlOlMapToolsAction',
  compatConfig: {
    MODE: 3
  },
  props: {
    tagName: {
      type: String,
      default: 'button'
    },
    icon: {
      type: String,
      default: ''
    },
    id: {
      type: String,
      default: ''
    },
    name: {
      type: String,
      default: ''
    },
    modDisabled: Boolean,
    modToggle: Boolean,
    modRadio: Boolean,
    modActive: Boolean,
    modError: Boolean,
    a11yLabel: {
      type: String,
      default: ''
    }
  },
  emits: ['change'],
  setup(props, { emit, attrs }) {
    const classes = computed(() => {
      return [
        'kl-ol-map-tools-action',
        {
          'kl-ol-map-tools-action--active': props.modActive,
          'kl-ol-map-tools-action--error': props.modError,
          'kl-ol-map-tools-action--disabled': props.modDisabled
        }
      ]
    })

    function clicked(e) {
      if (e.target.tagName !== 'A') {
        emit('change')
      }
    }

    return {
      classes,
      clicked
    }
  }
})
